import React from 'react'
import Navbar from '../defaultComponents/Navbar.jsx'
import Footer from '../defaultComponents/Footer.jsx'
import { 
  DataGrid, 
  GridToolbar, 
  GridToolbarFilterButton, 
  GridToolbarDensitySelector, 
  GridToolbarColumnsButton, 
  GridToolbarContainer, 
  GridToolbarExport 
} from '@mui/x-data-grid';

import TextField from '@mui/material/TextField';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import {
  useNavigate
} from "react-router-dom";

export default function DeviceGrid() {
  let navigate = useNavigate();

  const [backendRows, setBackendRows] = React.useState("")
  
  // Device Page Filters
  const [deviceType, setDeviceType] = React.useState('');
  const [department, setDepartment] = React.useState('')
  const [status, setStatus] = React.useState('')
  const [firstName, setFirstName] = React.useState('')
  const [lastName, setLastName] = React.useState('')

  const handleDeviceFilter = (event) => {
    setDeviceType(event.target.value);
  };

  const handleDepartmentFilter = (event) => {
    setDepartment(event.target.value);
  }

  const handleStatusFilter = (event) => {
    setStatus(event.target.value);
  }

  const handleFirstnameFilter = (event) => {
    setFirstName(event.target.value);
  }

  const handleLastnameFilter = (event) => {
    setLastName(event.target.value);
  }

  const clearFilters = () => {
    setFirstName('');
    setLastName('');
    setDepartment('');
    setStatus('');
    setDeviceType('');
  
    getData();
  }

  const CustomToolbar = () => {

    /*
      <GridToolbarColumnsButton color= "error" />
      <GridToolbarFilterButton color="error" />
    */
    return (
      <GridToolbarContainer>
          <GridToolbarDensitySelector color="error" />
          <GridToolbarExport color="error" />
      </GridToolbarContainer>
    );
  };

  const gotoDatabaseAdd = () => {
    navigate('/deviceDetails/addUser')
  }

  const gotoUpdateLaptop = () => {
    navigate('/deviceDetails/updateLaptop')
  }

  const gotoUpdateMobile = () => {
    navigate('/deviceDetails/updateMobile')
  }

  const getFilteredData = async () => {

    const filters = {
      "f_first": firstName,
      "f_last": lastName,
      "f_dev": deviceType,
      "f_dep": department,
      "f_status": status
    }

    await fetch('https://ic360portalbackend.azurewebsites.net/api/deviceDetails/filtered', {
      method: 'POST',
      headers: {
        'Content-type': 'application/JSON',
      },
      body: JSON.stringify({
        filters
      })
    })
    .then(response => response.json())
    .then (data => {
      setBackendRows(data)
    })
  }

  const getData = async () => {
    await fetch('https://ic360portalbackend.azurewebsites.net/api/deviceDetails')
    .then(response => response.json())
    .then (data => {
      setBackendRows(data)
    })
  }

  React.useEffect(() => {
    getData()
  }, []);

  const columns = [
    { field: 'FirstName', headerName: 'First name', width: 150 },
    { field: 'LastName', headerName: 'Last name', width: 150 },
    { field: 'DeviceType', headerName: 'Device Type', width: 100 },
    { field: 'Model', headerName: 'Model', width: 150 },
    { field: 'Department', headerName: 'Department', width: 150 },
    { field: 'ActiveStatus', headerName: 'Status', width: 100 },
    { field: 'DeviceCode', headerName: 'Device Code', width: 100 },
    //{ field: 'AssetNum', headerName: 'Asset Num', width: 100},
    { field: 'MobileNum', headerName: 'Mobile Num', width: 120}
  ];

  /*
    Add these buttons to device-buttons-bar if trying to test api
    <div className='device-page-button' onClick={test_post} >Add device</div>
    <div className='device-page-button' onClick={test_delete} >Delete device</div>
  */

  return (
    <>
      <Navbar/>
      <div className="all-page-background" style={{background: "#F8F8F8", width: "100%", height: "100%"}}>
      <div className="device-page-wrapper">
        <div className ="device-buttons-bar">
          <div className='device-page-button device-page-refresh' onClick={getData}>
            Refresh
            <span class="tooltiptext">*only refreshes if database changed</span>
          </div>
          <div className='device-page-button' onClick={gotoDatabaseAdd} >Add device</div>          
          <div className='device-page-button' onClick={gotoUpdateLaptop} >Update/Delete laptop</div>
          <div className='device-page-button' onClick={gotoUpdateMobile} >Update/Delete mobile</div>
        </div>
        <div className="device-filter-wrapper">

          <div className="device-search-wrapper">
            <TextField
              id="standard-search"
              label="First Name"
              variant="standard"
              color='error'
              value = {firstName}
              onChange={handleFirstnameFilter}
            />
          </div>
          <div className="device-search-wrapper">
            <TextField
              id="standard-search"
              label="Last Name"
              variant="standard"
              color='error'
              value = {lastName}
              onChange={handleLastnameFilter}
            />
          </div>

          <FormControl 
            color='error'
            sx={{width: 150}}
            >
          <InputLabel 
            id="demo-simple-select-label"
            sx={{width: 150}}
          >Device Type</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={deviceType}
            label="Device Type"
            onChange={handleDeviceFilter}
          >
            <MenuItem value={'IPHONE'}>iPhone</MenuItem>
            <MenuItem value={'IPHONE'}>iPad</MenuItem>
            <MenuItem value={'ANDROID'}>Android</MenuItem>
            <MenuItem value={'LAPTOP'}>Laptop</MenuItem>
          </Select>
          </FormControl>          

          <FormControl 
            color='error'
            sx={{width: 150}}
          >
          <InputLabel 
            id="demo-simple-select-label"
            sx={{width: 150}}
            >Department</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={department}
            label="Department"
            onChange={handleDepartmentFilter}
          >
            <MenuItem value={'IT'}>IT</MenuItem>
            <MenuItem value={'HR'}>HR</MenuItem>
            <MenuItem value={'BUSINESS'}>Business</MenuItem>
            <MenuItem value={'WHS'}>WHS</MenuItem>
            <MenuItem value={'ADMIN'}>Admin</MenuItem>
            <MenuItem value={'ACCOUNTS'}>Accounts</MenuItem>
            <MenuItem value={'OPERATIONS'}>Operations</MenuItem>
            <MenuItem value={'DESIGN'}>Design</MenuItem>
            <MenuItem value={'SITE'}>Site</MenuItem>
            <MenuItem value={'TRAFFIC'}>Traffic</MenuItem>
            <MenuItem value={'LABOUR'}>Labour</MenuItem>
            <MenuItem value={'ENG'}>Eng</MenuItem>
          </Select>
          </FormControl>

          <FormControl color='error' sx={{width: 150}}>
          <InputLabel id="demo-simple-select-label" sx={{width: 150}}>Status</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={status}
            label="Status"
            onChange={handleStatusFilter}
          >
            <MenuItem value={'ACTIVE'}>Active</MenuItem>
            <MenuItem value={'INACTIVE'}>Inactive</MenuItem>
            <MenuItem value={'MAINTENANCE'}>Maintenance</MenuItem>
          </Select>
          </FormControl>
        </div>

        <div className="device-buttons-bar device-filter-bar">
          <div className="device-page-button" onClick={getFilteredData}zz>Apply filters</div>
          <div className="device-page-button" onClick={clearFilters}>Clear filters</div>
        </div>
        
        <div style={{ height: 620, width: '100%' }}>
        <DataGrid
          rows={backendRows}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5]}
          checkboxSelection
          slots={{ toolbar: CustomToolbar }}
        />
        </div>
      </div>
      
      <Footer/>
      </div>
    </>
  )
}
